interface BadgeProps {
  label: string;
  color?: 'primary' | 'secondary' | 'tertiary' | 'neutral' | 'white';
  size?: 'sm' | 'md';
  className?: string;
}

const colorClasses = {
  primary: 'bg-primary text-white',
  // Sand is deepened (#8a6a34) so white text clears AA.
  secondary: 'bg-secondary text-white',
  tertiary: 'bg-tertiary text-white',
  neutral: 'bg-on-surface/8 text-on-surface',
  // `white` deprecated (was translucent-on-dark). Aliased to a quiet surface chip.
  white: 'bg-surface text-on-surface border border-line',
};

const sizeClasses = {
  sm: 'text-xs px-2.5 py-0.5',
  md: 'text-sm px-3 py-1',
};

export default function Badge({
  label,
  color = 'primary',
  size = 'md',
  className = '',
}: BadgeProps) {
  return (
    <span
      className={`inline-block rounded-full font-semibold ${colorClasses[color]} ${sizeClasses[size]} ${className}`}
    >
      {label}
    </span>
  );
}
